import React from 'react';

export const SearchIcon = ({ className, color = '#7E7E7E' }) => (
  <div className={className}>
    <svg width="18" height="21" viewBox="0 0 18 21">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 10.2561 15.0661 12.2941 13.5638 13.7484L17.5 18.5C17.8623 18.9168 17.8182 19.5484 17.4013 19.9108C16.9845 20.2731 16.3529 20.2289 15.9906 19.8121L11.9605 14.9525C10.7927 15.6191 9.44085 16 8 16ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" fill={color} />
    </svg>
  </div>
);
